import { defineMessages, IntlShape } from "react-intl";

import { getDisplayName } from "@app/util/ui";

enum SortField {
  UPDATED_AT = "updatedAt",
  NAME = "name",
}

const messages = defineMessages<SortField>({
  [SortField.NAME]: {
    id: "settings.fileTags.sort.field.name",
    defaultMessage: "Name",
    description: "Name field label",
  },
  [SortField.UPDATED_AT]: {
    id: "settings.fileTags.sort.field.updatedAt",
    defaultMessage: "Date Modified",
    description: "Date Modified field label",
  },
});

export const getSortFieldDisplayName = (intl: IntlShape, sortField: SortField) =>
  getDisplayName(intl, messages, sortField, "SortField");

export default SortField;
